import { types, flow } from 'mobx-state-tree'

import { DataStore } from './data-store/data-store'

const SPModel = types.model('SPModel', {
  id: types.number,
  name: types.string,
  image: types.string,
})

const ActiveShiftModel = types.model('ActiveShiftModel', {
  id: types.number,
  status_id: types.number,
  client_checkin_time: types.maybeNull(types.string),
  client_checkout_time: types.maybeNull(types.string),
  hours: types.number,
  sp: SPModel,
})

export const AttendanceReportJobModel = types.model('Shift', {
  id: types.number,
  start_time: types.string,
  end_time: types.string,
  time_to_auto_confirm: types.number,
  pending_shifts: types.number,
  job_id: types.number,
  work_category_name: types.string,
  client_location_name: types.string,
  order_id: types.number,
  active_shifts: types.array(ActiveShiftModel),
})

export const attendanceReportJobActions = (self: DataStore) => ({
  fetchAttendanceReportJob: flow(function* ({
    clientLocationId,
    workCategoryId,
  }: {
    clientLocationId?: number | null
    workCategoryId?: number | null
  }) {
    const params = new URLSearchParams()
    if (clientLocationId) {
      params.set('client_location_id', String(clientLocationId))
    }
    if (workCategoryId) {
      params.set('work_category_id', String(workCategoryId))
    }
    const query = params.toString()
    const url = query ? `client/attendance/shifts/v2?${query}` : 'client/attendance/shifts/v2'

    const shifts = (yield self.request('get', url)).list as AttendanceReportSnapshot[]
    self.attendanceReportJob.clear()
    shifts.forEach((shift: AttendanceReportSnapshot) => {
      self.attendanceReportJob.set(String(shift.id), shift)
    })
  }),
  updateAttendanceReportShift: flow(function* (updatedAttendance) {
    yield self.request('post', `client/attendance/shifts/process`, updatedAttendance)
  }),
})

export const attendanceReportJobViews = (self: DataStore) => ({
  attendanceReportJobView() {
    return Array.from(self.attendanceReportJob.values())
  },
})

export type AttendanceReport = typeof AttendanceReportJobModel.Type
export type AttendanceReportSnapshot = typeof AttendanceReportJobModel.SnapshotType
export type ActiveShift = typeof ActiveShiftModel.Type
